// extracted by mini-css-extract-plugin
export default {"header":"PaymentReportingHeader_header__TIwgF","title":"PaymentReportingHeader_title__NNF-y","controls":"PaymentReportingHeader_controls__ppqlD"};